<template>
  <v-application>
    <v-card tile class="ma-2" :loading="loading_w_order">
      <v-layout row px-2 pt-2 mx-2>
        <v-btn text @click="goBack">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t("back") }}
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="
            currentWorkgroupOrder.state == 'draft' ||
              (currentWorkgroupOrder.state == 'pending' &&
                currentWorkgroupOrder.employees &&
                currentWorkgroupOrder.employees.length == 0)
          "
          text
          color="primary"
          @click="editWorkgroupOrder"
        >
          <v-icon>mdi-pencil</v-icon>
          {{ $t("edit_workgroup_order") }}
        </v-btn>
        <v-btn
          v-if="
            ![
              'completed',
              'complete_confirmed',
              'rejected',
              'cancelled'
            ].includes(currentWorkgroupOrder.state)
          "
          color="error"
          text
          @click="cancelCurrentOrder()"
        >
          <v-icon>mdi-close</v-icon>
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          text
          v-if="currentWorkgroupOrder.state == 'rejected'"
          @click="undoCurrentOrder()"
        >
          <v-icon>mdi-undo</v-icon>
          {{ $t("undo_rejecked") }}
        </v-btn>
        <v-btn
          v-if="currentWorkgroupOrder.state == 'completed'"
          color="primary"
          text
          @click="confirm_complete = true"
        >
          {{ $t("confirm_complete") }}
        </v-btn>
      </v-layout>
      <v-card-title>
        <p class="green--text ma-0 pa-0">
          Order № {{ currentWorkgroupOrder.order_number }}
        </p>
      </v-card-title>
      <v-card-text class="px-5">
        <!-- Item -->
        <p
          class="green--text ma-0 pa-0 font-weight-medium"
          style="margin-left: -5px"
        >
          {{ $t("item") }}
        </p>
        <v-layout row>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("name") }}</label>
            <br />
            <label class="black--text">{{
              currentWorkgroupOrder.item_name
            }}</label>
          </v-flex>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("count") }}</label>
            <br />
            <label class="black--text">{{
              currentWorkgroupOrder.order_item_count
            }}</label>
          </v-flex>
        </v-layout>

        <v-divider class="my-2"></v-divider>

        <!-- Info -->
        <p class="green--text ma-0 pa-0 font-weight-medium">
          {{ $t("info") }}
        </p>
        <v-layout row>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("state") }}</label
            ><br />
            <label class="black--text">{{
              $t(currentWorkgroupOrder.state)
            }}</label>
          </v-flex>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("title") }}</label
            ><br />
            <label class="black--text">{{ currentWorkgroupOrder.title }}</label>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("date_created") }}</label
            ><br />
            <label class="black--text">{{
              date_ddmmyy_hhmm(currentWorkgroupOrder.createdAt)
            }}</label>
          </v-flex>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("store") }}</label
            ><br />
            <label class="black--text">{{
              currentWorkgroupOrder.service_name
            }}</label>
          </v-flex>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <v-layout row>
          <v-flex px-3 md6 sm12 xs12>
            <label class="caption">{{ $t("comment") }}</label
            ><br />
            <label class="black--text">{{
              currentWorkgroupOrder.comment
            }}</label>
          </v-flex>
          <v-flex px-3 md2 sm12 xs12>
            <label class="caption">{{ $t("total") }}</label
            ><br />
            <label class="black--text">
              {{ total_computed_cost.toLocaleString() }}
              <!-- {{
                workgroup_totals.total_cost
                  ? workgroup_totals.total_cost.toLocaleString()
                  : workgroup_totals.total_cost
              }} -->
            </label>
          </v-flex>
          <!-- <v-flex px-3 md2 sm12 xs12>
            <label class="caption">{{ $t("total_actual_cost") }}</label
            ><br />
            <label class="black--text">
              {{
                workgroup_totals.total_actual_cost
                  ? workgroup_totals.total_actual_cost.toLocaleString()
                  : workgroup_totals.total_actual_cost
              }}
            </label>
          </v-flex>
          <v-flex px-3 md2 sm12 xs12>
            <label class="caption">{{ $t("total_production_cost") }}</label
            ><br />
            <label class="black--text">
              {{
                workgroup_totals.total_production_cost
                  ? workgroup_totals.total_production_cost.toLocaleString()
                  : workgroup_totals.total_production_cost
              }}
            </label>
          </v-flex> -->
        </v-layout>
        <v-layout row>
          <v-flex
            px-3
            md6
            sm12
            xs12
            v-for="(comm, ind) in workgroup_comments"
            :key="ind + 'A'"
          >
            <label class="caption">{{ comm }}</label>
            <br />
            <label class="black--text">
              {{ currentWorkgroupOrder.info[comm] }}
            </label>
          </v-flex>
        </v-layout>
        <v-divider
          v-if="currentWorkgroupOrder.comment != ''"
          class="my-2"
        ></v-divider>

        <p class="green--text ma-0 pa-0 font-weight-medium mb-4">
          {{ $t("workgroups") }}
        </p>
        <div
          v-for="(w_name, n) in currentWorkgroupOrder.workgroup_names"
          :key="n"
        >
          <v-layout row px-2 mx-2>
            <span
              class="dot"
              :class="
                currentWorkgroupOrder.active_workgroup_order == n + 1
                  ? 'dot2'
                  : ''
              "
            >
              <p style="font-weight: medium; color: white; margin-top: 2px">
                {{ n + 1 }}
              </p>
            </span>
            <p class="mx-5 black--text">
              {{ w_name.name }}
            </p>
            <p
              v-if="currentWorkgroupOrder.active_workgroup_order == n + 1"
              class="font-weight-bold black--text"
            >
              {{ $t(currentWorkgroupOrder.state) }}
            </p>
          </v-layout>
          <v-layout row px-2 mx-2>
            <p v-if="w_name.employee" class="mx-5 black--text font-weight-bold">
              {{ w_name.employee.employee_name }} -
              {{ $t(w_name.employee.state) }}
            </p>
          </v-layout>
          <v-layout
            row
            class="px-5 mx-5"
            v-if="w_name.employee && w_name.employee.device_name"
          >
            <span>{{ $t("device_name") }} - </span>
            <span class="mx-3 black--text">
              {{ w_name.employee.device_name }}
            </span>
          </v-layout>

          <v-layout
            row
            class="px-5 mx-5"
            v-if="w_name.employee && w_name.employee.chooseanTime"
          >
            <span>{{ $t("start_time") }} - </span>
            <span class="mx-3 black--text">
              {{ date_ddmmyy_hhmm(w_name.employee.chooseanTime) }}
            </span>
          </v-layout>

          <v-layout
            row
            class="px-5 mx-5"
            v-if="w_name.employee && w_name.employee.finishTime"
          >
            <span>{{ $t("finish_time") }} - </span>
            <span class="mx-3 black--text">
              {{ date_ddmmyy_hhmm(w_name.employee.finishTime) }}
            </span>
          </v-layout>

          <v-layout row px-2 mx-2>
            <v-spacer />
            <v-btn text class="mx-2" @click="showShifts(n)">{{
              $t("show_shifts")
            }}</v-btn>
            <v-btn text class="mx-2" @click="showInfoDialog(n, 'additional')">{{
              $t("show_additional_info")
            }}</v-btn>
            <v-btn text class="mx-2" @click="showInfoDialog(n, 'order')">{{
              $t("show_order_info")
            }}</v-btn>
            <v-btn text class="mx-2" @click="showInfoDialog(n, 'device')">{{
              $t("show_device_info")
            }}</v-btn>
          </v-layout>
          <v-divider class="my-3"></v-divider>
        </div>

        <v-layout row px-4>
          <span class="green--text ma-0 pa-0 font-weight-medium">
            {{ $t("workgroup_items") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              access &&
                access.workgroup_edit_cost &&
                ['pending', 'in_progress', 'completed'].includes(
                  currentWorkgroupOrder.state
                )
            "
            icon
            color="primary"
            @click="showItemEdit"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-layout>
        <v-data-table
          :headers="item_headers"
          disable-sort
          hide-default-footer
          :items="currentWorkgroupOrder.items"
          :items-per-page="10000"
        >
          <template v-slot:[`item.production_item`]="{ item }">
            {{
              item.production_item
                ? Math.round(item.production_item * 100) / 100
                : item.production_item
            }}
          </template>
          <template v-slot:[`item.residue`]="{ item }">
            {{
              item.residue ? Math.round(item.residue * 100) / 100 : item.residue
            }}
          </template>

          <template v-slot:[`item.quantity`]="{ item }">
            {{
              item.quantity ? Math.round(item.quantity * 100) / 100 : item.quantity
            }}
          </template>

          <template v-slot:[`item.used_quantity`]="{ item }">
            {{
              item.used_quantity ? Math.round(item.used_quantity * 100) / 100 : item.used_quantity
            }}
          </template>
          <!-- <template v-slot:[`item.quantity`]="{ item }">
            {{
              (item.quantity ? item.quantity : 0) +
              (item.used_quantity ? item.used_quantity : 0)
                ? Math.round(
                    ((item.quantity ? item.quantity : 0) +
                      (item.used_quantity ? item.used_quantity : 0)) *
                      100
                  ) / 100
                : (item.quantity ? item.quantity : 0) +
                  (item.used_quantity ? item.used_quantity : 0)
            }}
          </template> -->
          <!-- <template v-slot:[`item.used_quantity`]="{ item }">
            {{
              item.used_quantity
                ? Math.round(item.used_quantity * 100) / 100
                : item.used_quantity
            }}
          </template> -->

          <template v-slot:[`item.cost`]="{ item }">
            {{ item.cost ? item.cost.toLocaleString() : item.cost }}
          </template>
          <template v-slot:[`item.total_cost`]="{ item }">
            {{ total_cost_of_item(item).toLocaleString() }}
            <!-- {{
              item.production_item * item.cost
                ? (
                    Math.round(item.production_item * item.cost * 100) / 100
                  ).toLocaleString()
                : 0
            }} -->
          </template>
          <template v-slot:[`item.waste`]="{ item }">
            <v-icon color="error" v-if="item.quantity < item.used_quantity"
              >mdi-alert-circle</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="confirm_complete" persistent width="800">
      <v-card>
        <v-card-title>{{ $t("confirm_complete") }}</v-card-title>
        <v-card-text>
          <v-layout row px-2>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('total_cost')"
                v-model="workgroup_totals.total_cost"
                v-bind:options="moneyOptionsUSD"
                readonly
              />
            </v-flex>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('additional')"
                v-model="workgroup_totals.additional_cost"
                v-bind:options="moneyOptionsUSD"
              />
            </v-flex>
          </v-layout>
          <v-layout row px-2>
            <v-flex px-2 md3>
              <v-text-field
                v-model="in_stock"
                type="number"
                @focus="$event.target.select()"
                :label="$t('in_stock')"
              />
            </v-flex>
            <v-flex px-2 md3>
              <v-checkbox v-model="add_to_stock" :label="$t('add_to_stock')" />
            </v-flex>
            <v-flex px-2 md6>
              <vuetify-money
                :label="$t('total_amount')"
                v-model="workgroup_totals.total_actual_cost"
                v-bind:options="moneyOptionsUSD"
                readonly
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="confirm_loading"
            text
            @click="confirm_complete = false"
            >{{ $t("cancel") }}
          </v-btn>
          <v-btn
            :loading="confirm_loading"
            text
            color="primary"
            @click="confirmCurrentOrder"
          >
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="workgroup_info" width="600">
      <v-card>
        <v-card-title>{{
          workgroup_info_type == "order"
            ? $t("order_info")
            : workgroup_info_type == "additional"
            ? $t("additional_info")
            : $t("device_info")
        }}</v-card-title>
        <v-card-text>
          <v-data-table
            :items-per-page="10000"
            disable-sort
            :headers="info_headers"
            :items="info_items"
            :loading="info_header_loading || info_data_loading"
            hide-default-footer
            :loading-text="$t('loading_info')"
            :no-data-text="$t('no_info_yet')"
          >
            <template v-slot:[`item.date`]="{ item }">
              {{ date_ddmmyy_hhmm(item.date) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="shift_info" width="600">
      <v-card>
        <v-card-title>{{ $t("shifts") }}</v-card-title>
        <v-card-text>
          <v-data-table
            :items-per-page="10000"
            disable-sort
            :headers="shift_headers"
            :items="current_shifts"
            hide-default-footer
            :loading="shifts_loading"
          >
            <template v-slot:[`item.opening_time`]="{ item }">
              {{ date_ddmmyy_hhmm(item.opening_time) }}
            </template>
            <template v-slot:[`item.closing_time`]="{ item }">
              {{ item.closing_time ? date_ddmmyy_hhmm(item.closing_time) : "" }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="items_edit_dialog" width="600" persistent>
      <v-card tile>
        <v-card-title>{{ $t("edit_items") }}</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="edit_item_headers"
            :items="items_data"
            hide-default-footer
            :items-per-page="1000"
            disable-sort
          >
            <template v-slot:[`item.quantity`]="{ item }">
              <v-text-field
                v-model="item.quantity"
                class="right-input"
                type="number"
                @focus="$event.target.select()"
              />
            </template>
            <template v-slot:[`item.cost`]="{ item }">
              <vuetify-money
                v-model="item.cost"
                v-bind:options="moneyOptionsUSD"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="items_edit_dialog = false" text>{{
            $t("cancel")
          }}</v-btn>
          <v-btn
            :loading="save_items_loading"
            text
            color="primary"
            @click="saveWItems"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
</template>

<script>
import WorkgroupOrder from "../../mixins/employees/workgroup_order";
import WorkgroupInfo from "../../mixins/employees/workgroup_info";
import WorkgroupComment from "../../mixins/employees/workgroup_comments";

export default {
  name: "workgroup-orders",
  mixins: [WorkgroupComment, WorkgroupInfo, WorkgroupOrder],
  data: () => ({
    currentWorkgroupOrder: {
      employees: [],
      info: {},
      additional_cost: 0,
      total_cost: 0
    },
    additionalOrders: true,
    stepper: 2,
    confirm_complete: false,
    additional: 0,
    payment_type: "cash",
    total_amount: 0,
    in_stock: 0,
    add_to_stock: false,
    confirm_loading: false,
    loading_w_order: false,
    info_headers: [],
    info_items: [],
    workgroup_info: false,
    workgroup_info_type: "order",
    info_header_loading: false,
    info_data_loading: false,
    shift_info: false,
    current_shifts: [],
    items_edit_dialog: false,
    items_data: [],
    save_items_loading: false,
    shifts_loading: false,
    workgroup_totals: {
      total_cost: 0,
      total_actual_cost: 0,
      additional_cost: 0
    }
  }),
  watch: {
    "currentWorkgroupOrder.total_actual_cost"() {
      if (this.currentWorkgroupOrder) {
        this.total_amount =
          +this.currentWorkgroupOrder.total_actual_cost + +this.additional;
      }
    },
    workgroup_info() {
      if (!this.workgroup_info) {
        this.info_headers = [];
        this.info_items = [];
      }
    },
    "workgroup_totals.additional_cost"() {
      this.setTotals();
    },
    confirm_complete() {
      this.setTotals();
    },
    "currentWorkgroupOrder.order_item_count"() {
      if (typeof this.currentWorkgroupOrder.order_item_count === "number") {
        this.in_stock = this.currentWorkgroupOrder.order_item_count;
      }
    }
  },
  computed: {
    current_workgroup_id() {
      return this.$route.query.id;
    },
    payment_types() {
      return [
        { text: this.$t("cash"), value: "cash" },
        { text: this.$t("card"), value: "card" },
        { text: this.$t("debt"), value: "debt" }
      ];
    },
    no_data_text() {
      return this.$t("no_workgroup_orders");
    },
    w_order_headers() {
      return [
        { text: "№", value: "order_number" },
        { text: this.$t("title"), value: "title" },
        { text: this.$t("state"), value: "state" },
        { text: this.$t("employee"), value: "current_employee_name" },
        {
          text: this.$t("created_date"),
          value: "createdAt",
          width: 150,
          align: "right"
        },
        { text: null, value: "warning", width: 30, align: "center" }
      ];
    },
    shift_headers() {
      return [
        { text: this.$t("opening_time"), value: "opening_time" },
        { text: this.$t("closing_time"), value: "closing_time" },
        { text: this.$t("comment"), value: "comment" }
      ];
    },
    item_headers() {
      return [
        { text: this.$t("name"), value: "product_name" },
        // {
        //   text: this.$t("used_quantity"),
        //   value: "used_quantity",
        //   width: 120,
        //   align: "right",
        // },
        {
          text: this.$t("quantity"),
          value: "quantity",
          width: 120,
          align: "right"
        },
        {
          text: this.$t("used_quantity"),
          value: "used_quantity",
          width: 120,
          align: "right"
        },
        {
          text: this.$t("residue"),
          value: "residue",
          width: 120,
          align: "right"
        },
        { text: this.$t("cost"), value: "cost", width: 120, align: "right" },
        {
          text: this.$t("total_cost"),
          value: "total_cost",
          width: 120,
          align: "right"
        },
        { text: null, value: "waste", width: 50, align: "center" }
      ];
    },
    edit_item_headers() {
      return [
        { text: this.$t("name"), value: "product_name" },
        {
          text: this.$t("quantity"),
          value: "quantity",
          align: "right",
          width: 100
        },
        { text: this.$t("cost"), value: "cost", align: "right", width: 120 }
      ];
    },
    total_computed_cost() {
      let total = this.currentWorkgroupOrder.additional_cost;
      if (typeof total !== "number") {
        total = 0;
      }
      try {
        for (const item of this.currentWorkgroupOrder.items) {
          total += this.total_cost_of_item(item);
        }
      } catch (error) {
        return 0;
      }
      return total;
    }
  },
  methods: {
    setTotals() {
      this.workgroup_totals.total_actual_cost =
        +this.total_computed_cost + +this.workgroup_totals.additional_cost;
      this.workgroup_totals.total_cost = this.total_computed_cost;
    },
    async getWorkgroupOrder() {
      this.loading_w_order = true;
      const result = await this.getWorkgroupOrderById(
        this.current_workgroup_id
      );
      if (!result) {
        return;
      }
      if (result.state != "complete_confirmed") {
        delete result.total_production_cost;
      }

      if (!result.info) {
        result.info = {};
      }
      this.currentWorkgroupOrder = result;
      this.loading_w_order = false;
    },
    total_cost_of_item(item) {
      if (!item.used_quantity) {
        item.used_quantity = 0;
      }
      if (!item.residue) {
        item.residue = 0;
      }
      if (!item.cost) {
        item.cost = 0;
      }

      return (item.used_quantity - item.residue) * item.cost;
    },
    async cancelCurrentOrder() {
      await this.cancelWorkgroupOrder(this.currentWorkgroupOrder._id);
      this.getWorkgroupOrder();
    },
    async undoCurrentOrder() {
      await this.undoWorkgroupOrder(this.currentWorkgroupOrder._id);
      this.getWorkgroupOrder();
    },
    async confirmCurrentOrder() {
      this.confirm_loading = true;
      await this.confirmWorkgroupOrder(this.currentWorkgroupOrder._id, {
        additional_cost: this.workgroup_totals.additional_cost,
        in_stock: this.in_stock,
        add_to_stock: this.add_to_stock
      });
      const result = await this.getWorkgroupOrderById(
        this.currentWorkgroupOrder._id
      );

      if (!result) {
        return;
      }
      if (result.state != "complete_confirmed") {
        delete result.total_production_cost;
      } else {
        this.workgroup_totals.total_production_cost =
          result.total_production_cost;
      }
      if (result && result.items) {
        this.currentWorkgroupOrder = result;
      }
      this.total_amount = 0;
      this.confirm_loading = false;
      this.confirm_complete = false;
      this.getWorkgroupOrder();
    },
    async showInfoDialog(index, type) {
      this.workgroup_info = true;
      this.workgroup_info_type = type;
      await this.getInfoHeaders(index, type);
      await this.getInfoData(index, type);
      if (type == "order") {
        const total = {
          date: this.$t("total")
        };
        for (const header of this.info_headers) {
          if (header.value != "date") {
            total[header.value] = 0;
          }
        }
        const isNumber = /^\d{1,}$/;
        for (const data of this.info_items) {
          for (const header of this.info_headers) {
            if (header.value != "date") {
              if (isNumber.test(data[header.value])) {
                total[header.value] += +data[header.value];
              }
            }
          }
        }

        this.info_items.push(total);
      }
    },
    async getInfoHeaders(index, type) {
      this.info_header_loading = true;
      const workgroup_id = this.currentWorkgroupOrder.workgroups[index];
      const result = await this.getWInfoHeaders(workgroup_id, type);
      if (result instanceof Array) {
        const headers = [{ text: this.$t("date"), value: "date" }];
        for (const r of result) {
          headers.push({
            text: r,
            value: r
          });
        }
        this.info_headers = headers;
      }
      this.info_header_loading = false;
    },
    async getInfoData(index, type) {
      this.info_data_loading = true;
      const workgroup_id = this.currentWorkgroupOrder.workgroups[index];
      const workgroup_order_id = this.currentWorkgroupOrder._id;
      const result = await this.getWInfoData(
        workgroup_id,
        workgroup_order_id,
        type
      );
      this.info_data_loading = false;
      if (result instanceof Array) {
        this.info_items = result;
      }
    },
    async showShifts(index) {
      this.current_shifts = [];
      this.shift_info = true;
      this.shifts_loading = true;
      if (this.currentWorkgroupOrder.employees[index]) {
        const result = this.$communicator.then(
          this,
          await this.$communicator("workgroup_order_shifts_get", {
            params: {
              service_id: this.currentWorkgroupOrder.service,
              user_id: this.currentWorkgroupOrder.employees[index].employee_id,
              time: this.currentWorkgroupOrder.employees[index].chooseanTime
            }
          })
        );
        if (result instanceof Array) {
          this.current_shifts = result;
        }
      }
      this.shifts_loading = false;
    },
    showItemEdit() {
      this.items_edit_dialog = true;
      const items = this.currentWorkgroupOrder.items;
      for (const index in items) {
        if (!items[index].quantity) {
          items[index].quantity = 0;
        }
        if (!items[index].used_quantity) {
          items[index].used_quantity = 0;
        }
        items[index].quantity += items[index].used_quantity;
      }
      this.items_data = JSON.parse(JSON.stringify(items));
    },
    async saveWItems() {
      this.save_items_loading = true;
      for (const index in this.items_data) {
        if (!this.items_data[index].quantity) {
          this.items_data[index].quantity = 0;
        }
      }
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_items_update", {
          params: {
            workgroup_order_id: this.currentWorkgroupOrder._id,
            items: this.items_data
          }
        })
      );
      this.save_items_loading = false;
      if (result) {
        this.items_edit_dialog = false;
      }
      this.getWorkgroupOrder();
    },
    editWorkgroupOrder() {
      // if (this.currentWorkgroupOrder.state == "draft") {
      this.$router
        .push(
          `/inventory/workgroup/orders/update?id=${this.currentWorkgroupOrder._id}`
        )
        .catch(() => {});
      // }
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  mounted() {
    this.getWorkgroupOrder();
    this.workgroup_comments_get();
  }
};
</script>

<style scoped>
.multi-line-truncate {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.v-btn {
  background-color: #e9f6e7 !important;
  text-transform: none !important;
}
.v-tab {
  text-transform: none !important;
}
.v-tabs-slider-wrapper .v-tabs-slider {
  background-color: none !important;
  height: 0;
}
.v-tab--active {
  color: white !important;
  background-color: #4baf4f;
}
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
.dot2 {
  background-color: #4baf4f;
}
</style>
